import {NavbarClientsDetailsComponent} from "./common/navbar-clients-details/navbar-clients-details.component";

declare let $: any;
import {Component} from '@angular/core';
import {filter} from 'rxjs/operators';
import {HeaderComponent} from './common/header/header.component';
import {FooterComponent} from './common/footer/footer.component';
import {ToggleService} from './common/sidebar/toggle.service';
import {SidebarComponent} from './common/sidebar/sidebar.component';
import {CommonModule, Location, LocationStrategy, PathLocationStrategy} from '@angular/common';
import {CustomizerSettingsComponent} from './customizer-settings/customizer-settings.component';
import {RouterOutlet, Router, NavigationCancel, NavigationEnd, RouterLink} from '@angular/router';
import {CustomizerSettingsService} from './customizer-settings/customizer-settings.service';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ChatService } from "./customs/_services/chat.service";
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';


registerLocaleData(localeFr);
@Component({
    selector: 'app-root',
    standalone: true,
    imports: [NgbModule, CommonModule, RouterOutlet, SidebarComponent, HeaderComponent, FooterComponent, RouterLink, CustomizerSettingsComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    providers: [
        Location,
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        { provide: LOCALE_ID, useValue: 'fr-FR' } // corrigé
    ]
})
export class AppComponent {

    title = 'iLab';
    routerSubscription: any;
    location: any;
    private subscriptions: Subscription[] = [];


    // isSidebarToggled
    isSidebarToggled = false;
    showLayout = true; // <<=== Ajouter cette ligne

    // isToggled
    isToggled = false;

    constructor(
        public router: Router,
        private toggleService: ToggleService,
        public themeService: CustomizerSettingsService,
        private snackBar: MatSnackBar,
        private chatService: ChatService,
    ) {
        this.toggleService.isSidebarToggled$.subscribe(isSidebarToggled => {
            this.isSidebarToggled = isSidebarToggled;
        });
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
this.router.events.subscribe((event) => {
  if (event instanceof NavigationEnd) {
    const token = sessionStorage.getItem('user_token');
    console.log('Token au changement de route:', token);
    
    const hiddenRoutes = [
      '/authentication',
      '/authentication/',
      '/authentication/sign-up',
      '/authentication/forgot-password',
      '/authentication/reset-password',
      '/authentication/lock-screen',
      '/authentication/confirm-email',
      '/authentication/logout',
      '/coming-soon'
    ];
    const currentPath = event.urlAfterRedirects.split('?')[0];
    this.showLayout = !hiddenRoutes.includes(currentPath);
  }
});

    }
    

    // ngOnInit
    ngOnInit() {
        this.recallJsFuntions();
            const notifSub = this.chatService.notificationReceived$.subscribe((notif) => {
      console.log('📣 Nouvelle notification reçue:', notif);

      // ✅ Méthode 1 : Snackbar Angular Material
      this.snackBar.open(notif || 'Nouveau message reçu', 'Fermer', {
        duration: 3000,
        panelClass: ['notification-snackbar']
      });

      // ✅ Méthode 2 : simple alert (débogage uniquement)
      // alert(notif.content || 'Nouveau message reçu');
    });

    this.subscriptions.push(notifSub);
    }

    // recallJsFuntions
    recallJsFuntions() {
        this.routerSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
            .subscribe(event => {
                this.location = this.router.url;
                if (!(event instanceof NavigationEnd)) {
                    return;
                }
                window.scrollTo(0, 0);
            });
    }

    // Dark Mode
    toggleTheme() {
        this.themeService.toggleTheme();
    }

    // Sidebar Dark
    toggleSidebarTheme() {
        this.themeService.toggleSidebarTheme();
    }

    // Right Sidebar
    toggleRightSidebarTheme() {
        this.themeService.toggleRightSidebarTheme();
    }

    // Hide Sidebar
    toggleHideSidebarTheme() {
        this.themeService.toggleHideSidebarTheme();
    }

    // Header Dark Mode
    toggleHeaderTheme() {
        this.themeService.toggleHeaderTheme();
    }

    // Card Border
    toggleCardBorderTheme() {
        this.themeService.toggleCardBorderTheme();
    }

    // Card Border Radius
    toggleCardBorderRadiusTheme() {
        this.themeService.toggleCardBorderRadiusTheme();
    }

    // RTL Mode
    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }

}
